var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSticker3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48.3 54.5",
    style: {
      enableBackground: "new 0 0 48.3 54.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#858589;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#E2DEDE;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st4{fill:#FA9A63;}\n\t.st5{fill:#FADC63;}\n\t.st6{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st7{fill:url(#);stroke:#000000;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n\t.st9{fill:#FFFFFF;}\n\t.st10{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35,24.4c0,1.5-2,2.7-4.5,2.7S26,25.9,26,24.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4,22.2c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.6,22.6c0-3.4,2.7-6.1,6.1-6.1s6.1,2.7,6.1,6.1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8,
    cy: 23.7,
    r: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.7,24.4c0,1.5-2,2.7-4.5,2.7s-4.5-1.2-4.5-2.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2,22.2c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.3,22.6c0-3.4,2.7-6.1,6.1-6.1s6.1,2.7,6.1,6.1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.6,
    cy: 23.7,
    r: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M44,28.3c0-0.1,0-0.1,0-0.2c0-10.9-8.8-19.7-19.7-19.7C13.5,8.4,4.7,17.2,4.6,28C2.3,30.6,1,33.6,1,36.9 c0,9.2,10.4,16.6,23.2,16.6s23.2-7.4,23.2-16.6C47.3,33.8,46.1,30.8,44,28.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.7,32.8c0,3.6-2.4,6.1-5.7,6.1S19,36,19,32.4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 24.4,
    cy: 40.7,
    rx: 11.9,
    ry: 8.6
  })), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 30,
    y1: 33.4,
    x2: 37,
    y2: 30.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 32.9,
    y1: 34.8,
    x2: 39.9,
    y2: 31.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 34.7,
    y1: 37.2,
    x2: 41.7,
    y2: 33.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 18.3,
    y1: 33.4,
    x2: 11.3,
    y2: 30.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 15.4,
    y1: 34.8,
    x2: 8.4,
    y2: 31.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 13.7,
    y1: 37.2,
    x2: 6.6,
    y2: 33.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.9,7.7C12.9,3.4,8.6,0,8.6,0S4.4,3.4,4.4,7.7s1.9,7.7,4.3,7.7S12.9,11.9,12.9,7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,7.7C44,3.4,39.7,0,39.7,0s-4.3,3.4-4.3,7.7s1.9,7.7,4.3,7.7S44,11.9,44,7.7z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSticker3);
export default __webpack_public_path__ + "static/media/sticker_3.2de95b2fe5ac554ac851957e66f9e033.svg";
export { ForwardRef as ReactComponent };